import {setSignInUserToken, setSignInCorpId, getSignInUserToken, getSignInCorpId, setSignInUserId} from './AuthUtils';

/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 */
const fetchJSON = (url, options = {}) => {
    const signInUserToken = getSignInUserToken();
    const signInCorpId = getSignInCorpId();
    if (!options.headers) {
        options.headers = {};
    }
    if (!options.method) {
        options.method = 'POST';
    }
    options.headers['Accept'] = 'application/json';
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    options.headers['Content-Type'] = 'application/json';
    options.headers['Access-Control-Allow-Origin'] = '*';
    options.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    options.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
    if (signInUserToken) {
        options.headers.signInUserToken = signInUserToken;
    }
    if (signInCorpId) {
        options.headers.signInCorpId = signInCorpId;
    }
    return fetch(url, options)
        .then(response => {
            const status = response.status;
            if (status !== 200) {
                if (status === 500) {
                    return response.json();
                } else {
                    let statusText = '状态码（' + status + '）';
                    if (!status) {
                        statusText = '';
                    }
                    let message = '网络或系统出现错误。' + statusText;
                    throw {success: false, errorCode: status, message};
                }
            }
            let signInUserTokenNew = response.headers.get('signInUserToken');
            let signInCorpIdNew = response.headers.get('signInCorpId');
            if (signInUserTokenNew) {
                setSignInUserToken(signInUserTokenNew);
            }
            if (signInCorpIdNew) {
                setSignInCorpId(signInCorpIdNew);
            }
            return response.json();
        })
        .then(json => {
            return json;
        })
        .catch(error => {
            throw error;
        });
};

/**
 *
 * @param url
 * @param options
 * @returns {Promise<any>}
 */
const fetchCommon = (url, options = {}) => {
    const signInUserToken = getSignInUserToken();
    const signInCorpId = getSignInCorpId();
    if (!options.headers) {
        options.headers = {};
    }
    if (!options.method) {
        options.method = 'POST';
    }
    options.headers['Accept'] = 'application/json';
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    options.headers['Access-Control-Allow-Origin'] = '*';
    options.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    options.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
    if (signInUserToken) {
        options.headers.signInUserToken = signInUserToken;
    }
    if (signInCorpId) {
        options.headers.signInCorpId = signInCorpId;
    }
    return fetch(url, options)
        .then(response => {
            if (response.status !== 200) {
                throw response;
            }
            let signInUserTokenNew = response.headers.get('signInUserToken');
            let signInCorpIdNew = response.headers.get('signInCorpId');
            if (signInUserTokenNew) {
                setSignInUserToken(signInUserTokenNew);
            }
            if (signInCorpIdNew) {
                setSignInCorpId(signInCorpIdNew);
            }
            return response.json();
        })
        .then(json => {
            return json;
        })
        .catch(error => {
            let message;
            let status = error.status;
            switch (status) {
                case 500:
                    message = '系统内部错误';
                    break;
                default:
                    message = '网络或系统出现错误，状态码（' + status + '）';
                    status = 999;
            }
            throw {status, message};
        });
};

/**
 *
 * @param url
 * @param options
 * @returns {Promise<Response>}
 */
const fetchDownload = (url, options = {}) => {
    const signInUserToken = getSignInUserToken();
    const signInCorpId = getSignInCorpId();
    if (!options.headers) {
        options.headers = {};
    }
    options.headers['method'] = 'GET';
    options.headers['credentials'] = 'include';
    options.headers['Content-Type'] = 'application/json';
    options.headers['Accept'] = 'application/json';
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    options.headers['Access-Control-Allow-Origin'] = '*';
    options.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    options.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
    if (signInUserToken) {
        options.headers.signInUserToken = signInUserToken;
    }
    if (signInCorpId) {
        options.headers.signInCorpId = signInCorpId;
    }
    return fetch(url, options)
        .then(
            response => {
                return response;
            }
        ).catch(error => {
            let message;
            let status = error.status;
            switch (status) {
                case 500:
                    message = '系统内部错误';
                    break;
                default:
                    message = '网络或系统出现错误，状态码（' + status + '）';
                    status = 999;
            }
            throw {status, message};
        });
};

/**
 *
 * @param url
 * @param options
 * @returns {Promise<Response>}
 */
const fetchDownloadBlobUrl = (url, options = {}) => {
    const signInUserToken = getSignInUserToken();
    const signInCorpId = getSignInCorpId();
    if (!options.headers) {
        options.headers = {};
    }
    options.headers['method'] = 'GET';
    options.headers['credentials'] = 'include';
    options.headers['Content-Type'] = 'application/json';
    options.headers['Accept'] = 'application/json';
    options.headers['X-Requested-With'] = 'XMLHttpRequest';
    options.headers['Access-Control-Allow-Origin'] = '*';
    options.headers['Access-Control-Allow-Headers'] = 'Origin, X-Requested-With, Content-Type, Accept';
    options.headers['Access-Control-Allow-Methods'] = 'PUT,POST,GET,DELETE,OPTIONS';
    if (signInUserToken) {
        options.headers.signInUserToken = signInUserToken;
    }
    if (signInCorpId) {
        options.headers.signInCorpId = signInCorpId;
    }
    return fetch(url, options)
        .then(
            response => {
                if (response.status === 200) {
                    return response.blob().then(blob => {
                        let blobUrl = window.URL.createObjectURL(blob);
                        return {success: true, blobUrl};
                    });
                } else {
                    return {success: false};
                }
            }
        ).catch(error => {
            let message;
            let status = error.status;
            switch (status) {
                case 500:
                    message = '系统内部错误';
                    break;
                default:
                    message = '网络或系统出现错误，状态码（' + status + '）';
                    status = 999;
            }
            throw {status, message};
        });
};

/**
 *
 * @param url
 * @param options
 * @returns {Promise<Response>}
 */
const fetchUpload = (url, uploadFiles, params) => {
    const formData = new FormData();
    for (const file of uploadFiles) {
        formData.append('files', file);
    }
    if (params) {
        formData.append('params', params);
    }
    return fetch(url, {
        method: 'POST',
        body: formData,
        headers: {
            'Accept': 'application/json',
            'signInUserToken': getSignInUserToken(),
            'signInCorpId': getSignInCorpId()
        }
    }).then(
        response => {
            if (response.status !== 200) {
                throw response;
            }
            let signInUserToken = response.headers.get('signInUserToken');
            let signInCorpId = response.headers.get('signInCorpId');
            if (signInUserToken) {
                setSignInUserToken(signInUserToken);
            }
            if (signInCorpId) {
                setSignInCorpId(signInCorpId);
            }
            return response.json();
        }
    ).catch(error => {
        let message;
        let status = error.status;
        switch (status) {
            case 500:
                message = '系统内部错误';
                break;
            default:
                message = '网络或系统出现错误，状态码（' + status + '）';
                status = 999;
        }
        throw {status, message};
    });
}

export {fetchJSON, fetchCommon, fetchDownload, fetchUpload, fetchDownloadBlobUrl};
